import React, { useEffect, useState } from 'react';
import { Route, Redirect, Switch, withRouter } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { handleFieldError } from "../../utils/form-validation";
import { isEmpty, get } from "lodash";
import asyncRoute from "../../helpers/hoc/asyncRoute";
import { checkPermission, PrivateRoute } from "../../utils/route-auth";
import { MODULE_PERMISSIONS } from "../../constants/permission";
import { getTenantAction } from "../../actions";
import routes from "../../routes";
import Select from "../../components/FormElements/Select";
import { formFields } from "./constant";

const BillingHistory = asyncRoute(() => import("./BillingHistory"));
const Invoice = asyncRoute(() => import("./Invoice"));
const Response = asyncRoute(() => import("./BillingHistory/Response"));
const Subscription = asyncRoute(() => import("./subscriptions"));


const permissionArray = [
  MODULE_PERMISSIONS.PAYMENT_TRANSACTION_HISTORY,
  MODULE_PERMISSIONS.PAYMENT_INVOICE,
  MODULE_PERMISSIONS.PAYMENT_SUBSCRIPTION_PLAN
];

// Functional Component
const Payment = (props) => {

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [submited, setSubmited] = useState(false);
  const [form, setForm] = useState({})
  const [isPlatformManager, setIsPlatformManager] = useState('')
  const [manageServiceTenantsList, setManageServiceTenantsList] = useState([])
  const [protectRouteAccesss, setProtectRouteAccesss] = useState({})
  const [paths, setPaths] = useState('');

  const tenantId = useSelector((state) => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
  const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
  const dispatch = useDispatch();


  useEffect(() => {
    const dataLocal = JSON.parse(localStorage.getItem("PreSignInData"));
    const preSignInState = JSON.parse(localStorage.getItem("PreSignInState"));
    if (dataLocal && dataLocal.responseList && dataLocal.responseList.length > 0) {
      const PaymentAccessAccountType = dataLocal.responseList.find((data) => data.tenantId == preSignInState.tenantId)
      setProtectRouteAccesss(PaymentAccessAccountType)
    }
    let Isplat = dataLocal.responseList[0].tenantType;
    let getLocalStorageValue = localStorage.getItem("selectedTenant") ? localStorage.getItem("selectedTenant") : "";
    form.tenantName = getLocalStorageValue;
    if (Isplat == "Platform Manager") {
      getTenantListAll();
    }
    setIsPlatformManager(Isplat);
  }, []);



  useEffect(() => {
    checkPathPermissions();
  }, [props.location.pathname, protectRouteAccesss]);


  const routeMapping = {
    "ATD PAYMENT SUBSCRIPTION-SUBSCRIPTION PLAN-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: SUBSCRIPTION PLAN": `${routes.containers.payment}/${routes.payment.subscription.name}`,
    "ATD PAYMENT SUBSCRIPTION-TRANSACTION HISTORY-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: TRANSACTION HISTORY": `${routes.containers.payment}/${routes.payment.billingHistory.name}`,
    "ATD PAYMENT SUBSCRIPTION-INVOICE-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: INVOICE": `/${routes.containers.payment}/${routes.payment.invoice.name}`,
  }

  const checkPathPermissions = () => {
    const priorityList = [
      "ATD PAYMENT SUBSCRIPTION-SUBSCRIPTION PLAN-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: SUBSCRIPTION PLAN",
      "ATD PAYMENT SUBSCRIPTION-TRANSACTION HISTORY-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: TRANSACTION HISTORY",
      "ATD PAYMENT SUBSCRIPTION-INVOICE-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: INVOICE"
    ];

    try {
      let availablePermissions = permissionArray
        .map((item) => checkPermission({ permissions: item }))
        .filter((item) => item !== false);

      console.log("availablePermissions", availablePermissions);
      // debugger;

      if (availablePermissions.length > 0) {
        // Sort availablePermissions based on the priority list
        availablePermissions.sort((a, b) => {
          return priorityList.indexOf(a) - priorityList.indexOf(b);
        });

        let defaultPermission = availablePermissions[0];
        console.log("defaultPermission", defaultPermission);

        let path = routeMapping[defaultPermission] || 'not-authorize';
        console.log("path", path);
        setPaths(path);
        console.log("protectRouteAccesss", protectRouteAccesss)
      } else {
        setPaths('not-authorize');
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "tenantName") {
      localStorage.setItem("selectedTenant", value);
      window.location.reload();
    }
  }

  const handleTouch = () => {

  }

  const getTenantListAll = async () => {
    await dispatch(getTenantAction({ tenantId, authToken, userId }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          responseList,
        } = data;
        if (status === "Success" && responseList && responseList.length > 0) {
          const List = responseList && responseList.filter((ele) => ele.accountType == 0 && ele.tenantMode == 0);
          const tenantList = List.map((data) => {
            return {
              id: data.tenantId,
              text: data.tenantName,
            };
          });
          setManageServiceTenantsList(tenantList)
          // setAlterAttributeConfig(responseList);
        } else {
          console.log("Platform list not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });


  }

  const { match } = props

  useEffect(() => {
    if (protectRouteAccesss && protectRouteAccesss.hasOwnProperty("tenantMode") && protectRouteAccesss.hasOwnProperty("accountType") && protectRouteAccesss.accountType == 1) {
      const newUrl = `${match.path}/${routes.payment.billingHistory.name}`
      props.history.push(newUrl);
    }
  }, [protectRouteAccesss])


  return (
    <div className='form__style'>
      {
        isPlatformManager != '' && isPlatformManager == "Platform Manager" ?
          <>
            <div className="position-relative">
              <div
                className="custom-test-select new offset-md-9 "
                style={{
                  position: "absolute",
                  top: "95px",
                  // right: "160px",
                  left: '0px',
                  zIndex: 99,
                }}
              >
                <label className="mb-2" for="tenantName">
                  Select Tenant : <span className="text-danger">*</span>
                </label>
                {/* <Select
                  onChange={handleChange}
                  onBlur={handleTouch}
                  value={form[formFields.tenantName.key]}
                  setting={formFields[formFields.tenantName.key]}
                  error={errors[formFields.tenantName.key]}
                  submited={submited}
                  toggle={() => { alert('toggle'); }}
                  touched={touched[formFields.tenantName.key]}
                  options={manageServiceTenantsList}
                /> */}

                <select
                  name="tenantName"
                  value={form.tenantName}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {manageServiceTenantsList.map((option) => (
                    <option value={option.text}>{option.text}</option>
                  ))}
                </select>
              </div>
            </div>

          </> : ''
      }

      <Switch>
        {
          protectRouteAccesss && protectRouteAccesss.hasOwnProperty("tenantType") && protectRouteAccesss.tenantType == "Platform Manager" ?
            <>
              <Route
                exact
                path={`${match.path}`}
                render={() => (
                  <Redirect
                    to={`${paths}`}
                  />
                )}
              />

              <PrivateRoute
                path={`${match.path}/${routes.payment.billingHistory.name}`}
                component={BillingHistory}
                permissions={MODULE_PERMISSIONS.PAYMENT_TRANSACTION_HISTORY}
                defaultRoute={"payment"}
              />
              <PrivateRoute
                path={`${match.path}/${routes.payment.invoice.name}`}
                component={Invoice}
                permissions={MODULE_PERMISSIONS.PAYMENT_INVOICE}
                defaultRoute={"payment"}
              />

              <PrivateRoute
                path={`${match.path}/${routes.payment.subscription.name}`}
                component={Subscription}
                permissions={MODULE_PERMISSIONS.PAYMENT_SUBSCRIPTION_PLAN}
                defaultRoute={"payment"}
              />
            </> : protectRouteAccesss && protectRouteAccesss.hasOwnProperty("tenantMode") && protectRouteAccesss.hasOwnProperty("accountType") && protectRouteAccesss.accountType == 0 && protectRouteAccesss.hasOwnProperty("tenantType") && protectRouteAccesss.tenantType != "Platform Manager" && protectRouteAccesss.tenantMode == 1 ?
              <>
                <Route
                  exact
                  path={`${match.path}`}
                  render={() => (
                    <Redirect
                      to={`${paths}`}
                    />
                  )}
                />

                <PrivateRoute
                  path={`${match.path}/${routes.payment.billingHistory.name}`}
                  component={BillingHistory}
                  permissions={MODULE_PERMISSIONS.PAYMENT_TRANSACTION_HISTORY}
                  defaultRoute={"payment"}
                />
                <PrivateRoute
                  path={`${match.path}/${routes.payment.invoice.name}`}
                  component={Invoice}
                  permissions={MODULE_PERMISSIONS.PAYMENT_INVOICE}
                  defaultRoute={"payment"}
                />

                <PrivateRoute
                  path={`${match.path}/${routes.payment.subscription.name}`}
                  component={Subscription}
                  permissions={MODULE_PERMISSIONS.PAYMENT_SUBSCRIPTION_PLAN}
                  defaultRoute={"payment"}
                />
              </> : protectRouteAccesss && protectRouteAccesss.hasOwnProperty("tenantMode") && protectRouteAccesss.hasOwnProperty("accountType") && protectRouteAccesss.accountType == 0 && protectRouteAccesss.hasOwnProperty("tenantType") && protectRouteAccesss.tenantType != "Platform Manager" && protectRouteAccesss.tenantMode == 0 ?
                <>
                  <Route
                    exact
                    path={`${match.path}`}
                    render={() => (
                      <Redirect
                        to={`${paths}`}
                      />
                    )}
                  />

                  <PrivateRoute
                    path={`${match.path}/${routes.payment.billingHistory.name}`}
                    component={BillingHistory}
                    permissions={MODULE_PERMISSIONS.PAYMENT_TRANSACTION_HISTORY}
                    defaultRoute={"payment"}
                  />
                  <PrivateRoute
                    path={`${match.path}/${routes.payment.invoice.name}`}
                    component={Invoice}
                    permissions={MODULE_PERMISSIONS.PAYMENT_INVOICE}
                    defaultRoute={"payment"}
                  />

                  <PrivateRoute
                    path={`${match.path}/${routes.payment.subscription.name}`}
                    component={Subscription}
                    permissions={MODULE_PERMISSIONS.PAYMENT_SUBSCRIPTION_PLAN}
                    defaultRoute={"payment"}
                  />
                </> : protectRouteAccesss && protectRouteAccesss.hasOwnProperty("tenantMode") && protectRouteAccesss.hasOwnProperty("accountType") && protectRouteAccesss.accountType == 1 ?
                  <>
                    <Route
                      exact
                      path={`${match.path}`}
                      render={() => (
                        <Redirect
                          to={`${match.path}/${routes.payment.billingHistory.name}`}
                        />
                      )}
                    />

                    <PrivateRoute
                      path={`${match.path}/${routes.payment.billingHistory.name}`}
                      component={BillingHistory}
                      permissions={MODULE_PERMISSIONS.PAYMENT_TRANSACTION_HISTORY}
                      defaultRoute={"payment"}
                    />
                  </> : ''
        }
      </Switch>
    </div>
  );
};

export default withRouter(Payment);
